import type { MeetingModelJson } from "@performyard/service-contracts";

import { useMeetingCalendarIntegration } from "../../MeetingsTable/hooks";

type UseCalendarIntegrationParams = {
	meeting: MeetingModelJson;
};

type UseCalendarIntegrationReturn = {
	isCalendarIntegrationEnabled: boolean;
	hasCalendarEvent: boolean;
	isCalendarMismatch: boolean;
	isNonOwnerSeriesEvent: boolean;
	calendarProvider: string | undefined;
};

/**
 * Hook for managing calendar integration state and checks.
 * Encapsulates feature flag, company settings, and user status checks.
 * @param meeting - The current meeting object
 */
export const useCalendarIntegration = ({ meeting }: UseCalendarIntegrationParams): UseCalendarIntegrationReturn => {
	const { isCalendarIntegrationEnabled, hasCalendarEvent, isCalendarMismatch, isNonOwnerSeriesEvent } =
		useMeetingCalendarIntegration(meeting);
	const calendarProvider = meeting.calendarEvent?.provider;

	return {
		isCalendarIntegrationEnabled,
		hasCalendarEvent,
		isCalendarMismatch,
		isNonOwnerSeriesEvent,
		calendarProvider,
	};
};
